import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

/** Base URL of the backend API (Caddy locally; the deployed gateway host per environment). Provided from the environment in `app.config.ts`. */
export const API_BASE_URL: InjectionToken<string> = new InjectionToken<string>('API_BASE_URL');

/** Same 60s budget the Firebase callables used. */
export const CALLABLE_TIMEOUT_MS = 60_000;

/** Set on the calls that must not carry a bearer token (login, refresh). */
export const SKIP_AUTH: HttpContextToken<boolean> = new HttpContextToken<boolean>(() => false);
